module.exports = __webpack_public_path__ + "img/code_snippet.451cd8a8.png";